import PropTypes from 'prop-types';
// @mui
import { Box, Typography, Stack, Tooltip, Skeleton } from '@mui/material';

export default function JobCandidateNavbar({
  isActive,
  setCurrentTab,
  JOB_DETAILS_TABS,
  candidatesCount,
  isCandidatesCountLoading,
}) {
  const HeaderSkeleton = (
    <Skeleton variant="text" width="100px" height="20px" />
  );

  const HeaderCountSkeletion = (
    <Skeleton variant="text" width="20px" height="20px" />
  );

  return (
    <Box
      sx={{
        borderRadius: '6px',
        border: theme => `1px solid ${theme.palette.border.primaryBlack3}`,
        backgroundColor: theme => theme.palette.background.default,
        px: '20px',
        py: '24px',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap="16px"
        justifyContent="space-between"
      >
        {Object.keys(JOB_DETAILS_TABS).map(item => (
          <Tooltip key={item} title={JOB_DETAILS_TABS[item].tooltip}>
            <Stack
              onClick={() => setCurrentTab(JOB_DETAILS_TABS[item].value)}
              sx={{
                cursor: 'pointer',
                color: theme =>
                  isActive === JOB_DETAILS_TABS[item].value
                    ? theme.palette.info.main
                    : 'inherit',
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Typography variant="subheading2" fontWeight={600}>
                {JOB_DETAILS_TABS[item].label}
              </Typography>

              <Typography>{`${candidatesCount[item]}`}</Typography>
            </Stack>
          </Tooltip>
        ))}
      </Stack>
    </Box>
  );
}

JobCandidateNavbar.propTypes = {
  isActive: PropTypes.string,
  setCurrentTab: PropTypes.func,
  JOB_DETAILS_TABS: PropTypes.object,
  candidatesCount: PropTypes.object,
  isCandidatesCountLoading: PropTypes.bool,
};
